<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'default' | 'dense'
  }>(),
  {
    variant: 'default',
  },
);

defineSlots<{
  default: () => unknown
}>();
</script>

<template>
  <div
    class="iad-scrollable flex gap-l snap-mandatory snap-x scroll-smooth overflow-auto gap-x-l -mx-m px-m
    group-[.is-prestige]:grid group-[.is-prestige]:gap-x-[19px] group-[.is-prestige]:grid-cols-none group-[.is-prestige]:grid-flow-col group-[.is-prestige]:-mr-0"
    :class="{
      'md:grid md:px-0 md:mx-0 md:grid-cols-3': variant === 'default',
      'sm:grid sm:px-0 sm:mx-0 sm:gap-x-m sm:grid-cols-2 lg:grid-cols-4': variant === 'dense',
    }"
  >
    <slot />
  </div>
</template>

<style scoped>
.iad-scrollable {
  /*
    handle scrollbar in windows:
    • -ms-overflow-style isn't working anymore
    • hide scrollbar on firefox
  */
  scrollbar-width: none;
  /*
    use ::-webkit-scrollbar for edge/chrome on windows
    https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-scrollbar
    https://www.digitalocean.com/community/tutorials/css-scrollbars
  */
  &::-webkit-scrollbar {
    display: none;
  }
}

.iad-scrollable :deep(> *) {
  @apply snap-start basis-[calc(100%-50px)] flex-shrink-0 flex-grow-0 scroll-m-m;
}
</style>
